import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from '@epicuro-next/ataraxia/accordion';
import { AlertModule } from '@epicuro-next/ataraxia/alert';
import { AsideMenuModule } from '@epicuro-next/ataraxia/aside-menu';
import { AvatarModule } from '@epicuro-next/ataraxia/avatar';
import { ClickOutsideModule } from '@epicuro-next/ataraxia/click-outside';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';
import { SwitchesModule } from '@epicuro-next/ataraxia/switches';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { DataConnectModule } from '@epicuro-next/data/connect';
import { ConnectStateModule } from '@epicuro-next/state/connect-state';
import { UserStateModule } from '@epicuro-next/state/user-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AtaraxiaContactsModule } from 'libs/ataraxia/contacts/src';

import { ConnectBusinessContactsComponent } from './components/business-contacts/business-contacts.component';
import { CallNotificationComponent } from './components/call-notification/call-notification.component';
import { ConnectAvailabilityComponent } from './components/connect-availability/connect-availability.component';
import { ConnectSettingsComponent } from './components/connect-settings/connect-settings.component';
import { ContactListComponent } from './components/contact-list/contact-list.component';
import { ParticipantComponent } from './components/participant/participant.component';
import { UserContactsWrapperComponent } from './components/user-contacts-wrapper/user-contacts-wrapper.component';
import { UserContactsComponent } from './components/user-contacts/user-contacts.component';
import { ConnectVideoComponent } from './container/connect-video/connect-video.component';
import { ConnectVideoEffects } from './effects/connect-video.effects';
import { ConnectInterceptor } from './interceptors/connect.interceptor';
import { ConnectPermissionsService } from './services/connect-permissions.service';
import { ConnectRoomService } from './services/connect-room.service';
import { ConnectVideoService } from './services/connect-video.service';

@NgModule({
  declarations: [
    ConnectVideoComponent,
    ConnectAvailabilityComponent,
    ConnectBusinessContactsComponent,
    UserContactsWrapperComponent,
    UserContactsComponent,
    CallNotificationComponent,
    ParticipantComponent,
    ContactListComponent,
    ConnectSettingsComponent,
  ],
  imports: [
    CommonModule,
    ConnectStateModule,
    DataConnectModule,
    OverlayModule,
    PortalModule,
    IconsModule,
    AlertModule,
    EffectsModule.forFeature([ConnectVideoEffects]),
    StoreModule,
    SwitchesModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective,
    AvatarModule,
    PopoverModule,
    UserStateModule,
    DragDropModule,
    AccordionModule,
    AsideMenuModule,
    ClickOutsideModule,
    AtaraxiaContactsModule,
  ],
  providers: [
    ConnectVideoService,
    ConnectRoomService,
    ConnectPermissionsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConnectInterceptor,
      multi: true,
    },
  ],
  exports: [
    ConnectAvailabilityComponent,
    ConnectBusinessContactsComponent,
    UserContactsWrapperComponent,
    UserContactsComponent,
    ContactListComponent,
  ],
})
export class ConnectModule {}
